import { ApiError } from './client';

// Detectors for backend TEMPLATE_VALIDATION rejections that the PWA can recover
// from with a picker sheet. Message strings come from:
//   ProphecyFulfillmentStrategy.ts → "You must select a Proppian role..."
//   EmotionalSpiralStrategy.ts     → "An emotional arc must be selected..."
//   TemplateEngineService.assignRole → "Role \"X\" is not available..."
//   EmotionalArcService.selectArcShape → "Cannot change arc shape after..."
//
// Codes are matched first (fast path); message regex is the fallback for any
// rejection that surfaces a stable string but is wrapped in a generic code.

function asApiError(err: unknown): ApiError | null {
  return err instanceof ApiError ? err : null;
}

export function isTemplateValidationError(err: unknown): err is ApiError {
  const api = asApiError(err);
  return api?.code === 'TEMPLATE_VALIDATION';
}

export function isRoleSelectionRequired(err: unknown): err is ApiError {
  const api = asApiError(err);
  if (!api) return false;
  if (api.code !== 'TEMPLATE_VALIDATION') return false;
  return /proppian role|must select a .*role/i.test(api.message);
}

export function isArcSelectionRequired(err: unknown): err is ApiError {
  const api = asApiError(err);
  if (!api) return false;
  if (api.code !== 'TEMPLATE_VALIDATION') return false;
  return /emotional arc.*selected|must.*select.*arc/i.test(api.message);
}

export function isRoleAlreadyTaken(err: unknown): err is ApiError {
  const api = asApiError(err);
  if (!api) return false;
  if (api.code !== 'VALIDATION_ERROR') return false;
  return /not available for assignment|already assigned/i.test(api.message);
}

export function isArcLocked(err: unknown): err is ApiError {
  const api = asApiError(err);
  if (!api) return false;
  if (api.code !== 'VALIDATION_ERROR') return false;
  return /cannot change arc shape/i.test(api.message);
}

export function isStaleTemplateState(err: unknown): err is ApiError {
  const api = asApiError(err);
  return api?.code === 'STALE_STATE';
}
